<template>
  <TransitionGroup tag="div" name="notification-row" class="relative flex flex-col gap-3">
    <slot />
  </TransitionGroup>
</template>

<script setup lang="ts"></script>

<style scoped>
:deep(.notification-row-enter-active) {
  transition:
    opacity var(--motion-duration-medium) var(--motion-easing-enter),
    transform var(--motion-duration-medium) var(--motion-easing-enter);
}

:deep(.notification-row-leave-active) {
  position: absolute;
  width: 100%;
  transition:
    opacity var(--motion-duration-medium) var(--motion-easing-exit),
    transform var(--motion-duration-medium) var(--motion-easing-exit);
}

:deep(.notification-row-enter-from),
:deep(.notification-row-leave-to) {
  opacity: 0;
  transform: translateY(var(--motion-distance-md));
}

:deep(.notification-row-move) {
  transition: transform var(--motion-duration-fast) var(--motion-easing-standard);
}

@media (prefers-reduced-motion: reduce) {
  :deep(.notification-row-enter-active),
  :deep(.notification-row-leave-active) {
    transition-duration: var(--motion-duration-fast);
  }

  :deep(.notification-row-enter-from),
  :deep(.notification-row-leave-to) {
    transform: none;
  }

  :deep(.notification-row-move) {
    transition: none;
  }
}
</style>
